export default {
  methods: {
    getData: (key) => _data[key],

    hasErrorMessage: () => !_.isEmpty(_error),
    getError: () => _error,

    hasAlert: () => !_.isEmpty(_alert),
    getAlert: () => _alert,

    getUser: () => _user,

    getUserPermissions: () => _userPermissions,

    getMenu: () => _menu,

    getConfig: () => _config,

    getConnections: () => _connections,

    getUrlParams: () => _urlParams,
  },
};
